import React from 'react'

import { useState } from 'react'
import YAML from 'yaml'

import * as U from '../../utils'

import PageH1 from '../../components/PageH1/PageH1'
import weapons from '../../databases/Weapons.json'
import ManyBoxes from '../../components/Spell/ManyBoxes'
import Page from '../../containers/Page/Page'
import { SideMenu } from '../../components/SideMenu/SideMenu'
import ManySpells from '../../components/Spell/ManySpells'
import { SelectorsByColumns } from './Abilities'
import { QGTitle1 } from '../Tools/TitleGenerator'
import PageH2 from '../../components/PageH2/PageH2'


const weaponsSideMenuSections = {
    'Weapons & Runes': [
        // 'Runes',
        'One-Handed Melee',
        'Two-Handed Melee',
        'One-Handed Ranged',
        'Two-Handed Ranged'
    ]
}

export default function Weapons({ hasNoMargins, onClick, buttonText }) {

    let [selectedCategory, setSelectedCategory] = useState('One-Handed Melee')

    const {Descriptions} = weapons

    document.title = 'Weapons'

    return (
        <Page key={selectedCategory} isSecondaryPage={true} hasNoMargins={hasNoMargins}>

            <div className='center-content margin-bottom-4'>
                <QGTitle1 text={"Weapons"} height={60}/>
            </div>

            <SelectorsByColumns nColumns={1} selectedSelectorName={selectedCategory} setSelectedSelectorName={setSelectedCategory} selectorData={[
                { name: 'One-Handed Melee', src: '/Icons/Items/Hand_Axe.png'},
                { name: 'Two-Handed Melee', src: '/Icons/Items/Ultra_Greatsword.png'},
                { name: 'One-Handed Ranged', src: '/Icons/Items/Handgun.png'},
                { name: 'Two-Handed Ranged', src: '/Icons/Items/Heavy_Crossbow.png'},
                { name: 'Wands', src: '/Icons/Items/Elemental_Wand.png'},
                // { name: 'Weapon Runes', src: '/Icons/Items/Traditional_Rune.png'},
            ]}/>

            { selectedCategory != null && (
                <div>
                    <PageH2>{selectedCategory}</PageH2>
                    <p>{ Descriptions[selectedCategory] }</p>
                    <ManySpells areItems={true} shouldSort={false} shouldAlignByHeight={false} onSpellClick={onClick} buttonText={buttonText} spells={ U.spellsFromObject(weapons[selectedCategory]) }/>
                </div>
            )}

            {/* <SideMenu sections={weaponsSideMenuSections}/> */}

        </Page>
    )
}